import React, { useContext, useState } from "react"
import styled, { css } from "styled-components"
import { toast } from "react-toastify"

import useWindowSize from "hooks/useWindowSize"

import { useIntl, FormattedMessage } from "react-intl"
import ScrollContext from "contexts/Scroll"
import { Link } from "gatsby"
import Clipboard from "react-clipboard.js"
import { mediaDown } from "styles/media"
import * as spacings from "styles/spacing"
import { H1 } from "styles/typography"
import { lime, sunny } from "styles/colors"
import Logo from "components/Logo"
import Button from "components/Button"
import CopySrc from "images/copy.png"
import ArrowSrc from "images/arrow.png"
import EmailForm from "components/EmailForm"
import DownloadButton from "components/DownloadButton"
import MobileMenu from "components/MobileMenu"
import ModalMobile from "components/ModalMobile"

const Container = styled.div`
  position: relative;
  height: ${props => `${props.height}px`};
  display: flex;
  flex-direction: column;
  padding: ${spacings.xxxxLarge} ${spacings.xxxxLarge};
  z-index: 9;

  ${mediaDown.medium`
    padding: 0px ${spacings.medium};
    padding-top: ${spacings.xLarge};
    padding-bottom: ${spacings.xxxLarge};
  `}

  ${mediaDown.small`
    padding-bottom: 0;
  `}
`

const Content = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
`

const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  max-width: 850px;

  ${mediaDown.small`
    max-width: 343px;
    justify-content: flex-end;
    padding-bottom: ${spacings.xxLarge};
  `}
`

const Title = styled(H1)`
  position: relative;
  background-image: -webkit-linear-gradient(0deg, ${lime} 0%, ${sunny} 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-bottom: 16px;
  font-weight: 600;
  line-height: 64px;

  &:after {
    content: attr(data-text);
    position: absolute;
    top: 0;
    left: 0;
    text-shadow: 0px 1px 30px rgba(0, 0, 0, 0.5);
    z-index: -2;
  }

  ${mediaDown.small`
    line-height: 44px;
    background-image: -webkit-linear-gradient(0deg, ${sunny} 0%, ${sunny} 100%);
  `}
`

const Subtitle = styled.p`
  color: ${sunny};
  font-size: 20px;
  padding-bottom: 58px;
  font-family: "Local Charter";

  ${mediaDown.small`
    max-width: 280px;
    line-height: 26px;
    font-size: 18px;
    padding-bottom: ${spacings.xLarge};
  `}
`

const Download = styled.div`
  display: flex;
  height: 88px;
  color: white;
`

const Copy = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 75px;

  &:after {
    content: "";
    position: absolute;
    top: calc((56px / 2) - 4px);
    right: -${spacings.large};
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: white;
  }

  ${mediaDown.small`
    width: 56px;
    min-width: 56px;

    &:after {
      display: none;
    }
  `}
`

const EnhancedClipboard = styled(Clipboard)`
  z-index: 10;
`

const Desc = styled.span`
  color: white;
  margin-top: ${spacings.medium};
  font-size: 12px;

  ${props =>
    props.bold &&
    css`
      font-weight: 600;
    `}
`

const MenuContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-end;
`

const Menu = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: ${sunny};
  font-size: 24px;
  text-align: right;
  line-height: 19px;
`

const MenuItem = styled(Link)`
  font-size: 24px;
  font-family: "Local Charter";
  font-style: italic;
  margin-bottom: ${spacings.medium};
  z-index: 100;

  &:hover {
    font-style: normal;
  }

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
`

const Home = () => {
  const intl = useIntl()
  const { topMenuRef } = useContext(ScrollContext)
  const [mobileModalVisible, setMobileModalVisible] = useState(false)
  const { height } = useWindowSize()

  return (
    <div>
    <Logo />
    <Container height={height}>
      
      <div className="hide-small-down-no-relative">
        <MobileMenu />
      </div>
      <Content>
        <Main>
          <Title data-text={intl.formatMessage({ id: "home.title" })}>
            <FormattedMessage id="home.title" />
          </Title>
          <Subtitle>
            <FormattedMessage id="home.subtitle" />
          </Subtitle>
          <DownloadButton />
        </Main>
        <div className="hide-small-up">
          <MenuContainer>
            <Menu ref={topMenuRef}>
              <MenuItem target="_blank" href="https://ninkitbaby.tumblr.com">
                <FormattedMessage id="home.menu.tumblr" />
              </MenuItem>
              <MenuItem
                target="_blank"
                href="https://www.instagram.com/ninkitbaby"
              >
                <FormattedMessage id="home.menu.instagram" />
              </MenuItem>
              <MenuItem href="mailto:contact@nink.app">
                <FormattedMessage id="home.menu.contact" />
              </MenuItem>
              <MenuItem href="#about">
                <FormattedMessage id="home.menu.about" />
              </MenuItem>
            </Menu>
          </MenuContainer>
        </div>
      </Content>
      <ModalMobile
        visible={mobileModalVisible}
        setMobileModalVisible={setMobileModalVisible}
      />
    </Container>
    </div>
  )
}

export default Home
